import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import { useCallback, useState } from 'react';
import { createSendContactUsMessageOutbound } from '../../api/outbound/commonOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { isLocalhostEnvironment } from '../../utils/utils';
import { OpenModalContainer } from '../openModalContainer';
import { TwemojiWrapper } from '../twemojiWrapper';
const MAX_LENGTH = isLocalhostEnvironment() ? 20 : 2000;
export const ContactUsModal = ({ onClose }) => {
    const [message, setMessage] = useState('');
    const socketSend = useSocketSend();
    const onChangeMessage = (event) => {
        setMessage(event.target.value);
    };
    const isTooLong = message.length > MAX_LENGTH;
    const isDisabled = !message || isTooLong;
    const onClickSend = useCallback(() => {
        if (isDisabled) {
            return;
        }
        socketSend(createSendContactUsMessageOutbound(message));
        onClose();
    }, [isDisabled, message, onClose, socketSend]);
    return (_jsx(OpenModalContainer, { title: 'Contact Us', maxWidth: 'md', children: _jsxs(DialogContent, { children: [_jsx(DialogContentText, { css: css `
            margin-bottom: 10px;
          `, children: "Give feedback, make a suggestion, report a problem, or ask a question!" }), _jsx(TextField, { variant: 'outlined', label: 'Message', value: message, onChange: onChangeMessage, fullWidth: true, multiline: true, rows: 5, autoCapitalize: 'none', autoComplete: 'off', error: isTooLong }), _jsxs(DialogContentText, { component: 'div', css: css `
            display: flex;
            flex-direction: row;
            gap: 3px;
            align-items: center;
            justify-content: end;
          `, children: [isTooLong && _jsx(TwemojiWrapper, { children: "\u26A0\uFE0F" }), _jsxs("div", { children: [message.length.toLocaleString(), "/", MAX_LENGTH.toLocaleString()] })] }), _jsxs("div", { css: css `
            display: flex;
            flex-flow: row wrap;
            gap: 10px;
            margin-top: 10px;
          `, children: [_jsx(Button, { variant: 'contained', color: 'secondary', onClick: onClickSend, disabled: isDisabled, children: "Send" }), _jsx(Button, { variant: 'contained', color: 'primary', onClick: onClose, children: "Cancel" })] })] }) }));
};
